/*
CC Attribution License
https://www.svgrepo.com/svg/532994/plus
*/

const PlusIcon = ({ size = "1em", className = "", style, stroke, ...props }) => {
    const strokeWidth = stroke !== undefined ? stroke : "var(--icon-stroke-width, 2)";

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`icon ${className}`}
            style={style}
            {...props}
        >
    <path d="M6 12H18M12 6V18"/>

        </svg>
    );
};

export default PlusIcon;
